import { Dispatch } from "@reduxjs/toolkit";
import gsap from "gsap";
import { RouletteBetStatus } from "../../../../constants/enum/roulette";
import { RouletteNumbers } from "../../../../constants/roulette";
import { getBusinessProfileAction } from "../../../../reducers/business.slice";
import {
  getBetHistoryAction,
  getRoulettesAction,
  updateBetStatus,
} from "../../../../reducers/roulette.slice";

const spinCount = 10;
const duration = 11.5;
const initialAngle = 360 / 38 / 2;

export const startRouletteAnimation = (
  nonce: number,
  boardSize: any,
  playWheelSfx: () => void,
  setBallContainerAngle: (angle: number) => void,
  setBallOffsetY: (offset: number) => void,
  dispatch: Dispatch<any>,
  account: string,
  cityId: number
) => {
  const nonceIndex = RouletteNumbers.findIndex(
    (value: number) => value === nonce
  );

  const tl = gsap.timeline();

  tl.call(
    () => {
      setBallContainerAngle(
        -360 * spinCount - 180 + (360 / 38) * nonceIndex + initialAngle
      );

      playWheelSfx();
    },
    [],
    0
  )
    .call(
      () => {
        setBallOffsetY(boardSize.offset.end);
      },
      [],
      duration
    )
    .call(
      () => {
        dispatch(updateBetStatus(RouletteBetStatus.FINISHED));
      },
      [],
      duration + 1
    )
    .call(
      () => {
        setBallContainerAngle(initialAngle);
        setBallOffsetY(boardSize.offset.start);
        dispatch(getBetHistoryAction({ account }));
        dispatch(getBusinessProfileAction({ itemId: 48, cityId }));
        dispatch(getRoulettesAction());
      },
      [],
      duration + 2
    );

  return tl;
};
